<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="发货预测名称">
              <global-select
                @change="()=>{queryParams.version=undefined}"
                :value.sync="queryParams.name"
                selectType="selectSearch"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastName"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="name"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :setParams="{ name: queryParams.name }"
                :value.sync="queryParams.version"
                selectType="selectSearch"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="version"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary" v-hasPermi="['mdm:mdmUomConversions:add']">导出汇总</a-button>
      <a-button @click="handleExportDetail" type="primary" v-hasPermi="['mdm:mdmUomConversions:add']">导出明细</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">

        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <span slot="operation" slot-scope="{ record, text }">
            <span v-if="!record.demandType || record.demandType !== 'FC2'">{{ text.quantity }}</span>
            <a v-else @click="handleOperation(text,record)" class="ml10">{{ text.quantity }}</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { apiListShipmentForecastSum } from '@/api/scp/shipmentForecast/shipmentForecastManagement'
  import { generateLsTableResData } from '@/utils/util.js';
  export default {
    // eslint-disable-next-line
    name: 'detail',
    components: {
    },
    data () {
      return {
        loading: false,
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiListShipmentForecastSum, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
            name: undefined,
            version: undefined
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columns: [
        ],
        uomClassOptions: [],
        unitOfMeasureList: [],
        unitOfMeasureListNew: []
      }
    },
    created () {
      this.queryParams.name = this.$route.params.name; // 从路由参数中获取 id 值
      this.queryParams.version = this.$route.params.version; // 从路由参数中获取 id 值
      this.getListShipmentForecastSum()
    },
    mounted () {
      this.onSearch()
    },
    methods: {
      handleExportDetail () {
        if (!this.queryParams.name || !this.queryParams.version) {
          this.$message.error('发货预测名称和版本必须不能为空')
          return
       }
        this.download('scp/scpSopShipmentForecast/exportShipmentForecastDetail', {
          ...this.queryParams
        }, `发货预测明细_${new Date().getTime()}.xlsx`)
      },
      handleOperation (text, record) {
        // if (!record.demandType || record.demandType !== 'FC1') {
        //   this.$message.error('没有找到明细数据')
        //   return
        // }
        this.$router.push({ path: `/shipmentForecastManagement/monthsDetail/${this.queryParams.name}/${this.queryParams.version}/${record.itemId}/${text.month}/${record.demandDepartment}` })
      },
      getListShipmentForecastSum () {
        this.columns = []
        apiListShipmentForecastSum(this.queryParams).then((response) => {
            if (response.code === 200) {
              const titleList = response.title
             // 使用 forEach 方法
                titleList.forEach(item => {
                  const columnsItem = {
                    title: item.indexName,
                    dataIndex: item.indexKey,
                    ellipsis: true,
                    align: item.indexKey === 'name' ? 'left' : 'center',
                    scopedSlots: { customRender: item.hasDetail === "true" ? 'operation' : null }
                  // scopedSlots: { customRender: 'operation' }
                  }
                  this.columns.push(columnsItem);
                });
            }
        })
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        if (!this.queryParams.name || !this.queryParams.version) {
          this.$message.error('发货预测名称和版本必须不能为空')
          return
       }
        this.download('scp/scpSopShipmentForecast/exportShipmentForecastSum', {
          ...this.queryParams
        }, `发货预测汇总_${new Date().getTime()}.xlsx`)
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },

      // 表单搜索
      onSearch () {
       // this.getListShipmentForecastSum()
       if (!this.queryParams.version) {
          this.$message.error('发货版本不能为空')
          return
       }
        this.loading = true
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
      //  const self = this;
        const tableDate = this.$refs.dataTable.getData();
        tableDate.then(function (response) {
          // 在这里处理返回的结果
         // debugger
         this.loading = false
        })
       },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
          name: undefined,
          version: undefined
        }
        // this.onSearch()
      }

    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
  </style>
